export const whoAreWe = {
	title: 'Who are we',
	content:
		'The company PaRELI s.r.o. was established in year 2013 with the goal of creating a "successful project", ' +
		'where we could continue to expand our expertise in creation of project documentation and constantly ' +
		'evolve. Idea behind the company is "do not perceive this activity as an occupation, but as a mission" ' +
		'and an intent to bring something new to the market. Demand for orders grew proportionally to gradual improvement ' +
		'of provided services, which led to the expansion of our team that currently holds 9 project engineers. ' +
		'We consider our choice in colleagues as the primary cause of our success, since every single one of them ' +
		'represents our company and because it takes only a single individual to ruin that which we\'ve spent years ' +
		'building. This is why only people that can work in our company are those that can identify with our ideals. ' +
		'The company PaRELI s.r.o. has a long term history of participation on building cityscapes and villages in ' +
		'Slovakia, where it cooperates with biggest agencies and developers in Slovak Republic and abroad.',
};
